export default {
      id: "tpms_temperature-usage",
      viewBox: "0 0 23 28",
      url: __webpack_public_path__ + "img/icons.svg#tpms_temperature",
      toString: function () {
        return this.url;
      }
    }